import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App /> {/* วาง Router ไว้ที่นี่เพียงครั้งเดียว */}
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
